import styled, { type StyledComponent } from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Link, type LinkProps } from 'react-router-dom'

export const LinkWrapperStyled: StyledComponent<LinkProps> = styled(Link)({
  color: hexColors.studio,
  textDecoration: 'underline',
})
